import currentFormatId from './current_format_id';
import { format as formatNumber } from '../number';

// Some multiples have "generated" fractions like 1.234/1 need to allow for . in the numerator
const fractionRegex = /^[0-9.]+\/\d+$/;

const toThreeDecimals = (number) => Math.round(number * 1000) / 1000;

const formatters = {
  // US
  1: (decimal) => (
    decimal >= 1 ? `+${Math.round(decimal * 100)}` : `-${Math.round((1 / decimal) * 100)}`
  ),
  // Decimal
  3: (decimal) => formatNumber(toThreeDecimals(1 + decimal)),
  // Indonesian
  5: (decimal) => (
    decimal >= 1 ? toThreeDecimals(decimal) : `-${toThreeDecimals(1 / decimal)}`
  ),
  // Chinese
  6: toThreeDecimals,
};

export default (fractionalPrice) => {
  if (!fractionalPrice) return fractionalPrice;

  // I have kept this check
  // I imagine in certain cases this function is wrongly called with not a fraction
  // It would be ideal to keep and respect a contract
  if (fractionRegex.test(fractionalPrice)) {
    const formatter = formatters[currentFormatId()];

    // eslint-disable-next-line no-eval
    return formatter ? formatter(eval(fractionalPrice)).toString() : fractionalPrice;
  }

  return fractionalPrice.toString();
};
